import { API_URL } from '../../../app-config/constants';
import type { MiniExperiment } from '../../../types/ExperimentDto';
import { get } from '../request';

const ENTRY = `${API_URL}/experiment-observer`;

getExperiments.operation = 'READ';
export function getExperiments(): Promise<MiniExperiment[]> {
    return get(`${ENTRY}/experiments`, {});
}
